module.exports = __webpack_public_path__ + "img/CrossChainBridge_icon6.e21c8cc1.svg";